module.exports = __webpack_public_path__ + "img/only-bg.c0ff30e2.svg";